import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FuseNavigationComponent } from './navigation.component';
import { FuseNavVerticalItemComponent } from './vertical/item/item.component';
import { FuseNavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { FuseNavVerticalGroupComponent } from './vertical/group/group.component';
import { FeatherIconModule } from '../../root/feather-icon.module';
import { MaterialModule } from '../../shared/material.module';
import { FuseNavigationService } from './navigation.service';
import { from } from 'rxjs';
import { genericHttpLoaderFactory } from 'src/app/shared/providers/delta-uilm-provider';
import { HttpClient } from '@angular/common/http';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FeatherIconModule,
        MaterialModule,
        TranslateModule.forChild(),
    ],
    exports: [FuseNavigationComponent],
    declarations: [
        FuseNavigationComponent,
        FuseNavVerticalGroupComponent,
        FuseNavVerticalItemComponent,
        FuseNavVerticalCollapsableComponent
    ]
})
export class FuseNavigationModule { }
